import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Sirve si recién quiero empezar o si ya vendí algo antes?',
  a: 'Es el sistema ideal para cualquier etapa. Si recién empezás, construís todo bien desde cero y evitás los errores caros que arruinan el primer intento. Si ya vendiste algo, ordenás tu negocio, mejorás márgenes y aprendés a escalar sin improvisar.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después de confirmar el pago recibís un email con el acceso a todos los tomos y bonos en formato PDF. En menos de 5 minutos ya podés empezar a leer desde cualquier dispositivo, celular, tablet o computadora.'
}, {
  q: '¿Es realmente para el mercado argentino?',
  a: 'Sí. Todo el contenido está pensado para la realidad local: precios con inflación, proveedores argentinos, Mercado Pago, tiendas online con checkouts en pesos y estrategias de Meta Ads con presupuesto en pesos argentinos.'
}, {
  q: '¿Necesito saber de diseño o tener máquinas de coser?',
  a: 'Para nada. El MasterPack te enseña a trabajar con talleres externos y proveedores que hacen la producción por vos. Tu rol es crear la marca, elegir los productos y ejecutar la estrategia de ventas.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía de devolución completa sin preguntas. Si abrís el material y sentís que no es lo que esperabas, te reintegramos el 100% del dinero. Así de simple.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Preguntas frecuentes" className="bg-ink" data-id="element-51" data-mp="rzb6125b7bu9">
      <div className="mx-auto max-w-3xl px-5 pt-[32px]" data-id="element-52" data-mp="s0vxgiwbuenw">
        <h2 className="text-center font-display text-3xl font-black text-white sm:text-4xl" data-id="element-53" data-mp="wxcl7bzm6r0g">
          ❓ Lo que más nos preguntan
        </h2>
        <div className="mt-10 divide-y divide-white/10 overflow-hidden rounded-2xl border border-white/10 bg-ink-2" data-id="element-54" data-mp="j0hcxlr6t3lg">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-55" data-mp="2pogelkqhgwcd" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors hover:bg-white/[0.03]" data-id="element-56" data-mp="2kvewz4yw6ip3">
                  <span className="text-sm font-bold text-white sm:text-base" data-id="element-57" data-mp="38l95xbg3bn42">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-gold" data-id="element-58" data-mp="33m4yap8tdxfu" /> : <PlusIcon className="h-5 w-5 shrink-0 text-celeste" data-id="element-59" data-mp="2ymjykcltll22" />}
                </button>
                <div className="grid transition-all duration-300 ease-in-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-60" data-mp="2ukyd42v7zyg9">
                  <div className="overflow-hidden" data-id="element-61" data-mp="1j6bbc8sp52aw">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-white/65" data-id="element-62" data-mp="1j8xkgcv8jpv8">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}